var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 73,
    viewBox: "0 0 51 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar People Surgeon Doctor Medic Health Mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.0917 52.0938H12.9355C11.2837 52.0937 9.64811 52.4191 8.12205 53.0512C6.596 53.6833 5.20939 54.6098 4.0414 55.7778C2.87342 56.9458 1.94692 58.3325 1.31483 59.8585C0.682727 61.3846 0.357401 63.0202 0.357422 64.672C0.357422 67.4505 0.918123 68.7519 5.38869 69.7033C5.38869 69.7033 20.4391 72.351 25.5138 72.351C30.5884 72.351 45.6388 69.7034 45.6388 69.7034C50.1094 68.7519 50.6701 67.4505 50.6701 64.672C50.6701 61.3361 49.3449 58.1368 46.9861 55.778C44.6272 53.4191 41.4279 52.0939 38.092 52.0939L38.0917 52.0938Z",
    fill: "#F6EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.5136 59.6406C23.5121 59.6406 21.5925 58.8455 20.1772 57.4302C18.7619 56.0149 17.9668 54.0953 17.9668 52.0938V47.0625H33.0604V52.0938C33.0604 54.0953 32.2653 56.0149 30.85 57.4302C29.4347 58.8455 27.5152 59.6406 25.5136 59.6406Z",
    fill: "#F2A783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.5136 59.6406C23.5121 59.6406 21.5925 58.8455 20.1772 57.4302C18.7619 56.0149 17.9668 54.0953 17.9668 52.0938V47.0625H33.0604V52.0938C33.0604 54.0953 32.2653 56.0149 30.85 57.4302C29.4347 58.8455 27.5152 59.6406 25.5136 59.6406Z",
    fill: "url(#paint0_linear_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.9255 35.9442C42.9692 35.6839 43.093 35.4438 43.2797 35.2572C43.4664 35.0706 43.7066 34.9469 43.9669 34.9033C45.1327 34.6961 46.1893 34.0879 46.954 33.1839C47.7188 32.28 48.1434 31.1371 48.1545 29.9531V26.1797C48.1432 24.9907 47.7148 23.8433 46.9442 22.9377C46.1736 22.0321 45.1095 21.4258 43.9376 21.2244C43.6862 21.1815 43.4532 21.0645 43.2687 20.8885C43.0841 20.7124 42.9562 20.4853 42.9015 20.2361C42.401 17.9987 41.1539 15.9983 39.3654 14.5639C37.5768 13.1295 35.3533 12.3465 33.0607 12.3438H17.9669C15.6742 12.3465 13.4507 13.1295 11.6622 14.5639C9.87362 15.9983 8.62653 17.9987 8.12604 20.2361C8.07129 20.4852 7.94347 20.7123 7.75892 20.8884C7.57436 21.0645 7.34148 21.1815 7.09006 21.2244C5.91811 21.4258 4.85402 22.0321 4.08335 22.9377C3.31269 23.8433 2.88435 24.9906 2.87305 26.1797V29.9531C2.88411 31.1371 3.30872 32.2799 4.0734 33.1839C4.83808 34.0879 5.89472 34.6961 7.06047 34.9033C7.32077 34.9469 7.56098 35.0706 7.74765 35.2572C7.93432 35.4438 8.05815 35.6839 8.10188 35.9442H42.9255Z",
    fill: "#F2A783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.9255 35.9442C42.9692 35.6839 43.093 35.4438 43.2797 35.2572C43.4664 35.0706 43.7066 34.9469 43.9669 34.9033C45.1327 34.6961 46.1893 34.0879 46.954 33.1839C47.7188 32.28 48.1434 31.1371 48.1545 29.9531V26.1797C48.1432 24.9907 47.7148 23.8433 46.9442 22.9377C46.1736 22.0321 45.1095 21.4258 43.9376 21.2244C43.6862 21.1815 43.4532 21.0645 43.2687 20.8885C43.0841 20.7124 42.9562 20.4853 42.9015 20.2361C42.401 17.9987 41.1539 15.9983 39.3654 14.5639C37.5768 13.1295 35.3533 12.3465 33.0607 12.3438H17.9669C15.6742 12.3465 13.4507 13.1295 11.6622 14.5639C9.87362 15.9983 8.62653 17.9987 8.12604 20.2361C8.07129 20.4852 7.94347 20.7123 7.75892 20.8884C7.57436 21.0645 7.34148 21.1815 7.09006 21.2244C5.91811 21.4258 4.85402 22.0321 4.08335 22.9377C3.31269 23.8433 2.88435 24.9906 2.87305 26.1797V29.9531C2.88411 31.1371 3.30872 32.2799 4.0734 33.1839C4.83808 34.0879 5.89472 34.6961 7.06047 34.9033C7.32077 34.9469 7.56098 35.0706 7.74765 35.2572C7.93432 35.4438 8.05815 35.6839 8.10188 35.9442H42.9255Z",
    fill: "url(#paint1_radial_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.16105 35.5566L6.76532 21.1768C6.59143 20.1333 8.16907 19.8693 8.34327 20.914L10.739 35.2938L9.16105 35.5566Z",
    fill: "#EDDFF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.5519 28.6547C20.5305 27.6761 20.5305 26.0895 19.5519 25.1109C18.5734 24.1324 16.9868 24.1324 16.0082 25.1109C15.0296 26.0895 15.0296 27.6761 16.0082 28.6547C16.9868 29.6333 18.5734 29.6333 19.5519 28.6547Z",
    fill: "#3D3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.0207 28.6547C35.9992 27.6761 35.9992 26.0895 35.0207 25.1109C34.0421 24.1324 32.4555 24.1324 31.4769 25.1109C30.4984 26.0895 30.4984 27.6761 31.4769 28.6547C32.4555 29.6333 34.0421 29.6333 35.0207 28.6547Z",
    fill: "#3D3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.4715 35.1475H36.1573C33.4547 35.1475 30.8574 34.265 28.5892 32.7958C27.5979 32.1537 25.0333 31.1105 22.4313 32.7958C20.1629 34.265 17.5657 35.1474 14.8632 35.1474H7.55469C7.69546 36.006 9.34541 51.384 25.5117 51.384C38.7157 51.384 42.4248 41.5669 43.4715 35.1475Z",
    fill: "#EAF5FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40.2891 35.2933L42.685 20.9136C42.859 19.8698 44.4366 20.1329 44.2629 21.1766L41.8672 35.5563L40.2891 35.2933Z",
    fill: "#E5C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M43.4715 35.1475H36.1573C33.4547 35.1475 30.8574 34.265 28.5892 32.7958C27.5979 32.1537 25.0333 31.1105 22.4313 32.7958C20.1629 34.265 17.5657 35.1474 14.8632 35.1474H7.55469C7.69546 36.006 9.34541 51.384 25.5117 51.384C38.7157 51.384 42.4248 41.5669 43.4715 35.1475Z",
    fill: "url(#paint2_radial_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M38.762 2.26698C32.8394 0.551445 20.8363 -0.215779 12.2653 2.26698C9.55387 3.05658 7.17213 4.70525 5.47833 6.96498C3.78453 9.22472 2.87027 11.9733 2.87305 14.7974V27.9023C13.1208 12.1513 37.9092 12.1553 48.1545 27.9023V14.7974C48.1572 11.9733 47.243 9.22468 45.5491 6.96494C43.8553 4.70521 41.4735 3.05656 38.762 2.26698Z",
    fill: "#BA7DE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M38.762 2.26698C32.8394 0.551445 20.8363 -0.215779 12.2653 2.26698C9.55387 3.05658 7.17213 4.70525 5.47833 6.96498C3.78453 9.22472 2.87027 11.9733 2.87305 14.7974V27.9023C13.1208 12.1513 37.9092 12.1553 48.1545 27.9023V14.7974C48.1572 11.9733 47.243 9.22468 45.5491 6.96494C43.8553 4.70521 41.4735 3.05656 38.762 2.26698Z",
    fill: "url(#paint3_linear_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M40.4607 52.3205C36.7244 56.8253 31.4108 59.6414 25.5138 59.6414C19.6167 59.6414 14.303 56.8254 10.5668 52.3203C7.6945 52.8714 5.10398 54.4061 3.24072 56.6605C1.37746 58.9148 0.357916 61.748 0.357422 64.6727C0.357422 67.4512 0.918123 68.7526 5.38853 69.704C5.38853 69.704 20.4391 72.3516 25.5138 72.3516C30.5884 72.3516 45.6388 69.704 45.6388 69.704C50.1094 68.7526 50.67 67.4512 50.67 64.6727C50.6694 61.748 49.6499 58.9149 47.7867 56.6606C45.9234 54.4063 43.333 52.8716 40.4607 52.3205Z",
    fill: "#BA7DE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.4607 52.3205C36.7244 56.8253 31.4108 59.6414 25.5138 59.6414C19.6167 59.6414 14.303 56.8254 10.5668 52.3203C7.6945 52.8714 5.10398 54.4061 3.24072 56.6605C1.37746 58.9148 0.357916 61.748 0.357422 64.6727C0.357422 67.4512 0.918123 68.7526 5.38853 69.704C5.38853 69.704 20.4391 72.3516 25.5138 72.3516C30.5884 72.3516 45.6388 69.704 45.6388 69.704C50.1094 68.7526 50.67 67.4512 50.67 64.6727C50.6694 61.748 49.6499 58.9149 47.7867 56.6606C45.9234 54.4063 43.333 52.8716 40.4607 52.3205Z",
    fill: "url(#paint4_linear_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.5519 28.6547C20.5305 27.6761 20.5305 26.0895 19.5519 25.1109C18.5734 24.1324 16.9868 24.1324 16.0082 25.1109C15.0296 26.0895 15.0296 27.6761 16.0082 28.6547C16.9868 29.6333 18.5734 29.6333 19.5519 28.6547Z",
    fill: "url(#paint5_radial_1734_13556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M35.0207 28.6547C35.9992 27.6761 35.9992 26.0895 35.0207 25.1109C34.0421 24.1324 32.4555 24.1324 31.4769 25.1109C30.4984 26.0895 30.4984 27.6761 31.4769 28.6547C32.4555 29.6333 34.0421 29.6333 35.0207 28.6547Z",
    fill: "url(#paint6_radial_1734_13556)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1734_13556",
    x1: 25.5136,
    y1: 59.6406,
    x2: 25.5136,
    y2: 47.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A783",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#F0A17F",
    stopOpacity: 0.123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#ED9777",
    stopOpacity: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#EA8E71",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E7876B",
    stopOpacity: 0.713
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#E58167",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#E47D64",
    stopOpacity: 0.928
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#E37B63",
    stopOpacity: 0.982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1734_13556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.559215 11.8102) scale(39.2298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A783",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#F2A682",
    stopOpacity: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#F1A481",
    stopOpacity: 0.068
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#F0A07E",
    stopOpacity: 0.153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#EE9B7A",
    stopOpacity: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#EC9475",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#E98B6F",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#E58167",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1734_13556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.87553 25.8249) scale(39.1041 39.1041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDFF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDDFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1734_13556",
    x1: 2.87305,
    y1: 14.2909,
    x2: 48.1543,
    y2: 14.2909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#A461D8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1734_13556",
    x1: 0.357422,
    y1: 62.336,
    x2: 50.6701,
    y2: 62.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#A461D8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1734_13556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4277 23.6322) scale(5.53134 5.53134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#3D3C3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#393837",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#2D2C2B",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242423"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1734_13556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8963 23.6322) scale(5.53134 5.53134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#3D3C3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#393837",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#2D2C2B",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDoctor);
export default __webpack_public_path__ + "static/media/avatar-doctor.60fcac3716ae83690b9469016394b576.svg";
export { ForwardRef as ReactComponent };